import React from 'react';
import { ImportReferenceEditTemplate } from 'themes/application/import-reference/pages';
import { observer } from 'mobx-react';
import { ImportReferenceEditViewStore } from 'application/import-reference/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportReferenceEditViewStore(rootStore), 'editView')
@observer
class ImportReferenceEdit extends React.Component {
    render() {
        return <ImportReferenceEditTemplate {...this.props} />
    }
}

export default ImportReferenceEdit;
